<template>
    <div class="wrapper-box">
        <web-header></web-header>
        <web-slide :data="data"></web-slide>
        <web-products :products="products"></web-products>
        <web-parallax></web-parallax>
        <web-footer></web-footer>
        <web-arrow-up></web-arrow-up>
    </div>
</template>
<script>
import header from "@/components/header";
import slide from "@/components/slide";
import content from "@/components/content";
import parallax from "@/components/parallax";
import footer from "@/components/footer";
import products from "@/components/categories/products";
import arrowUp from "@/components/arrowUp.vue";
import bg from "../../assets/images/categories/banners/titulo_suplementos.jpg";
import bgMob from "../../assets/images/categories/banners/titulo_suplementos.jpg";

import img1 from "../../assets/images/products/suplementos_calcioaves.jpg";
import img2 from "../../assets/images/products/suplementos_hical.jpg";
import img3 from "../../assets/images/products/suplementos_calcioreptiles.jpg";
import img4 from "../../assets/images/products/suplementos_eggbiscuits.jpg";

export default {
  name: "suplementos",
  data() {
    return {
      data: [
        {
          html:
            " <h1>SUPLEMENTOS</h1> <p>Para crear una dieta sana y nutritiva.</p>",
          style:
            "background:url(" +
            this.getBg() +
            ") no-repeat; background-size:cover;    background-position: center; height:300px; "
        }
      ],
      products: [
        {
          image: img1,
          title: "CALCIO PARA AVES",
          description: `
-	Promueve la adecuada formación del cascaron del huevo durante la temporada de cria.<br>
-	Favorece el desarrollo del esqueleto en aves jovenes<br>
-	Se utiliza para el tratamiento y la prevención de la deficiencia de calcio<br>
-	Suplemento dietético orgánico <br>
Modo de empleo:<br>
Nelsoni Ranch recomienda consultar a un especialista para adecuar la dieta de su mascota. La dosificación recomendada es un 2% de Calcio sobre la ración, para que resulte mas fácil puede usarse similar a la sal espolvoreando sobre el alimento. <br>Se aprovecha muy bien en alimentos como pastones, bizcocho, pasta de huevo, frutas e insectos dependiendo la dieta<br>
Recuerde que el calcio en las aves asegura una buena formación de la cáscara del huevo y estimula la creación de un esqueleto sano
`,
          extraData: "Presentación: 120 gr."
        },
        {
          image: img2,
          title: "HI-CAL GRIT",
          description: `
-	Suplemento mineral para Aves<br>
-	El Grit es utilizado por las aves para ayudar en la digestión de las semillas enteras e intactas. Por lo tanto, favorece la molienda y el desgaste de las capas exteriores de las semillas, permitiendo a las enzimas digestivas llegar a la parte interna tan valiosa.<br>
-	El Grit es orgánico, el mismo se digiere fácilmente evitando que se acumule en el sistema digestivo. Al mismo tiempo proporciona el calcio adicional y otros minerales importantes para las aves alimentadas con una dieta a base de semillas <br>
-	Instrucciones: mezclar con el Mix de semillas a razón de un 2 % de Grit. <br>
También puede administrarse en cazuelas o lengüeteros de manera permanente para que el ave regule según su necesidad.
`,
          extraData: "Presentación: 120 gr."
        },
        {
          image: img3,
          title: "CALCIO PARA REPTILES (Oyster Shell) ",
          description: `Es una excelente fuente de calcio para todos los reptiles y anfibios. Compuesto por 100% carbonato de calcio organico.<br>
-	Modo Empleo:<br>
-	Espolvorear sobre frutas y verduras, hasta que quede una pequeña capa de calcio. Si va a alimentar con insectos:<br>
-	1- Colocar el Calcio para Reptiles Nelsoni Ranch en un recipiente<br>
-	2- Coloque los insectos dentro del recipiente<br>
-	3- Agitar suavemente hasta que estén completamente cubiertos  
`,
          extraData: "Presentación: 120 gr."
        },
        {
          image: img4,
          title: "EGG BISCUITS",
          description: `-	La proteína del huevo es una fuente muy importante para mantener a las aves en buenas condiciones y obtener buenos resultados de cría. <br>
-	Modo de Empleo: <br>
-	1- Listo para usar. Puede emplearse con o sin agregado de agua <br>
-	2- Proporcionar de 1 a 3 cucharaditas por porción. Periodo de descanso: 2 a 3 veces por semana. Periodo de cría: 2 a 3 veces por día según las necesidades. Periodo de muda: todos los días. <br>
-	Se puede proporcionar a todas las aves. <br>
-	Para mejores resultados, descartar cualquier porción no consumida y mantener el recipiente de comida limpio para la siguiente porción.  <br>
-	INGREDIENTES: huevos frescos, semillas de chía, harina de trigo y azucar.   

`,
          extraData: "Presentación: 120 gr."
        }
      ]
    };
  },
  components: {
    webHeader: header,
    webSlide: slide,
    webContent: content,
    webParallax: parallax,
    webFooter: footer,
    webProducts: products,
    webArrowUp: arrowUp
  },
  methods: {
    detectmob() {
      if (window.screen.availWidth <= 800) {
        return true;
      } else {
        return false;
      }
    },
    getBg() {
      if (this.detectmob()) {
        return bgMob;
      }
      return bg;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/categories/suplementos.vue